module.exports = __webpack_public_path__ + "img/shoppingCard.f191b46b.svg";